import {persistReducer} from "redux-persist";
import {CookieStorage} from 'redux-persist-cookie-storage'
import {takeLatest} from "redux-saga/effects";
import {forgetLastLocation} from "../../router/RouterHelpers";
import Cookies from 'cookies-js';

export const actionTypes = {

    Login: "[Login] Action",
    UpdateProfile: "[UpdateProfile] Action",
    Logout: "Logout",
    ExpireToken: "ExpireToken",
    Register: "[Register] Action",
    UserLoaded: "[Load User] Auth API",
    ForcePasswordUpdate: "ForcePasswordUpdate",
    PasswordUpdated: "PasswordUpdated",
    UpdateUser: "UpdateUser",
    UpdateLocale: "UpdateLocale",
};

const initialAuthState = {
    user: undefined,
    authToken: undefined
};

const cookie = new CookieStorage(Cookies);

export const reducer = persistReducer(
    {storage: new CookieStorage(Cookies), key: "auth", whitelist: ['user', "authToken"]},
    (state = initialAuthState, action) => {
        switch (action.type) {
            case actionTypes.Login: {
                const {authToken, user} = action.payload;
                return {...state, user, authToken};
            }

            case actionTypes.Logout: {
                forgetLastLocation();
                return cookie.setItem('persist:auth', {});
            }

            case actionTypes.ForcePasswordUpdate: {
                const user = Object.assign({}, state.user);
                user.reset_password = true;
                return {...state, ...{user}};
            }

            case actionTypes.PasswordUpdated: {
                const user = Object.assign({}, state.user);
                user.reset_password = false;
                return {...state, ...{user}};
            }

            case actionTypes.ExpireToken: {
                return {...state, ...{user: action.payload}};
            }

            case actionTypes.UpdateUser: {
                const {user} = action.payload;
                return {...state, user};
            }

            default:
                return state;
        }
    }
);


export const actions = {
    login: (authToken, user) => ({type: actionTypes.Login, payload: {authToken, user}}),
    logout: () => ({type: actionTypes.Logout}),
    updateUser: (user) => ({type: actionTypes.UpdateUser, payload: {user}}),
    passwordUpdated: () => ({type: actionTypes.PasswordUpdated}),
};

export function* saga() {
    yield takeLatest(actionTypes.Login, function* loginSaga() {
    });
    //incase we need registration
    yield takeLatest(actionTypes.Register, function* registerSaga() {
    });
}
